// extracted by mini-css-extract-plugin
export default {"primary":"#a69b95","primary_lighter":"#d5cfcc","primary_darker":"#9a8e87","secondary":"#53585a","secondary_lighter":"#858c8e","secondary_darker":"#474b4d"};